import axios from 'axios';
import { errorHandler } from "@/services/errorHandler";

export default {
  namespaced: true,
  state: {
    productBillingCycles: [],
    subscriptions: [],
    loading: false
  },
  mutations: {
    SET_PRODUCT_BILLING_CYCLES(state, cycles) {
      state.productBillingCycles = cycles;
    },
    SET_SUBSCRIPTIONS(state, subscriptions) {
      state.subscriptions = subscriptions;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    }
  },
  actions: {
    async fetchProductBillingCycles({ commit }) {
      commit('SET_LOADING', true);
      try {
        const response = await axios.get(window.subscriptionApi + 'product-billing-cycles');
        commit('SET_PRODUCT_BILLING_CYCLES', response.data);
        return response.data;
      } catch (error) {
        await errorHandler.tomcatError(error);
        return [];
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async fetchSubscriptions({ commit }) {
      commit('SET_LOADING', true);
      try {
        const response = await axios.get(window.subscriptionApi + 'subscriptions');
        commit('SET_SUBSCRIPTIONS', response.data);
        return response.data;
      } catch (error) {
        await errorHandler.tomcatError(error);
        return [];
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async createProductBillingCycle({ dispatch }, data) {
      try {
        await axios.post(window.subscriptionApi + 'product-billing-cycles', data);
        await dispatch('fetchProductBillingCycles');
        return true;
      } catch (error) {
        await errorHandler.tomcatError(error);
        return false;
      }
    },
    async updateProductBillingCycle({ dispatch }, { id, data }) {
      try {
        await axios.put(window.subscriptionApi + `product-billing-cycles/${id}`, data);
        await dispatch('fetchProductBillingCycles');
        return true;
      } catch (error) {
        await errorHandler.tomcatError(error);
        return false;
      }
    },
    async deleteProductBillingCycle({ dispatch }, id) {
      try {
        await axios.delete(window.subscriptionApi + `product-billing-cycles/${id}`);
        await dispatch('fetchProductBillingCycles');
        return true;
      } catch (error) {
        await errorHandler.tomcatError(error);
        return false;
      }
    }
  },
  getters: {
    getProductBillingCycles: state => state.productBillingCycles,
    getSubscriptions: state => state.subscriptions,
    isLoading: state => state.loading,
    getProductBillingCycleByProductAndCycle: state => (productId, cycleId) => {
      return state.productBillingCycles.find(
        pbc => pbc.product_id === productId && pbc.billing_cycle_id === cycleId
      );
    }
  }
};
